import { Platform, Pressable, ScrollView, StyleSheet, View } from 'react-native';
import { Stack } from 'expo-router';
import { CustomTextStyles } from '@/components/CustomText';
import { Link, Redirect, Tabs, RelativePathString, usePathname, useRouter } from 'expo-router';
import { Button } from 'react95-native-rabbl';
import { Image } from 'expo-image';
import { AppText } from '@/components/AppText';
import DrawerButton from '@/components/DrawerButton';
import { HeaderLeft } from '@/components/HeaderLeft';

const styles = StyleSheet.create({
  image28x28: {
    width: 28,
    height: 28,
    marginHorizontal: 10, 
  },
});

export default function AllDomainsLoggedInStack() {
  return (
    <Stack
      screenOptions={{
        // Remove horizontal bottom line for header
        headerShadowVisible: false,

        headerStyle: {
          backgroundColor: 'transparent',
        },

        headerBackTitle: '',

        headerBackButtonDisplayMode: 'minimal',
        
        headerTitle: (props) => <AppText {...props} style={CustomTextStyles.headerTitle} />,

        headerLeft: () => <HeaderLeft />,

        headerRight: () => <DrawerButton />,

        animation: 'none',
      }}
    >
      <Stack.Screen name="settings" options={{ title: 'Settings' }} />
      <Stack.Screen name="changepassword" options={{ title: 'Change Password' }} />
    </Stack>
  );
}
